import axios from 'axios'
import config from './config.js'
import moment from 'moment'

var $http = {}

let tokens = /SfsSes=(\w+)/gi.exec(location.href);

$http.SfsSes = sessionStorage && sessionStorage.getItem("SfsSes");
if (tokens && tokens.length > 1) {
  $http.SfsSes = tokens[1];
  if (sessionStorage) {
    sessionStorage.setItem("SfsSes", $http.SfsSes);
    location.replace(location.href.replace(/&?SfsSes=(\w+)/gi, ''));
  }
}

//axios.defaults.headers["withCredentials"] = true;
//axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
//axios.defaults.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
axios.interceptors.request.use(function (config) {
  if (config.loading === undefined || config.loading) {
    config.loading = "loading"
    // console.log("loading...")
  }
  return config;
}, function (error) {
  if (error.config.loading) {
    // console.log("loading end...")
  }
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  if (response.config.loading) {
    // console.log("loading end...")
  }
  return response;
}, function (error) {
  if (error.config.loading) {
    // console.log("loading end...")
  }
  return Promise.reject(error);
});
$http.ajax = function (url, data, method, options) {
  if (options === undefined)
    options = {};
  options.url = url;
  options.data = data;
  options.method = method;
  options.withCredentials = true;
  if ($http.SfsSes != undefined) {
    options.headers = options.headers || {};
    options.headers.SfsSes = $http.SfsSes;
  }

  return axios(options).then(function (response) {
    if (!response.data.isSucc && options.failTips == undefined || options.failTips) {
      $utils.fail(response.data.message, 'fail')
      $utils.ErrorMessage.push(response.data.message);
      if ($utils.ErrorMessage.length > 5) {
        $utils.ErrorMessage = $utils.ErrorMessage.slice($utils.ErrorMessage.length - 5, $utils.ErrorMessage.length)
      }
      if (response.data.statusCode == 511) {
        location.href = '/login'
        return;
      }
    }
    return response
  }).catch(function (error) {
    if (options.failTips == undefined || options.failTips) {
      $utils.fail(error.message, 'fail')
    } else {
      console.log(error);
    }
  });
}
$http.get = function (url, options) {
  if (options === undefined)
    options = {};
  return $http.ajax(url, options.data !== undefined ? {
    data: options.data
  } : "", "get", options);
}
$http.post = function (url, data, options) {
  if (options === undefined)
    options = {};

  for (var d in data) {
    if (data[d] instanceof Date) {
      data[d] = moment(data[d]).format("YYYY-MM-DD HH:mm:ss");
    }
  }
  return $http.ajax(url, $.param({
    data: typeof (data) == "object" ? JSON.stringify(data) : data
  }), "post", options);
}
export default $http



// WEBPACK FOOTER //
// ./src/apis/http.js